var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFavoriteIcon = function SvgFavoriteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    stroke: "#999",
    strokeWidth: 0.1,
    d: "M7.295 11.913a.464.464 0 0 1-.268.087h-.05a.452.452 0 0 1-.268-.087C3.423 9.527 1.47 7.202 1.392 7.11a3.7 3.7 0 0 1-.883-2.677 3.686 3.686 0 0 1 1.238-2.527 3.584 3.584 0 0 1 5.12.362L7 2.425l.133-.157a3.587 3.587 0 0 1 5.12-.362 3.69 3.69 0 0 1 1.238 2.527 3.703 3.703 0 0 1-.878 2.671c-.08.098-2.033 2.423-5.318 4.809Zm5.278-7.416a2.746 2.746 0 0 0-.925-1.884 2.67 2.67 0 0 0-1.776-.675c-.756 0-1.51.319-2.042.945l-.457.535a.455.455 0 0 1-.349.162h-.05a.458.458 0 0 1-.349-.162l-.456-.535a2.68 2.68 0 0 0-3.818-.27 2.75 2.75 0 0 0-.925 1.885c-.05.733.184 1.441.662 2.001.018.024 1.868 2.22 4.908 4.472 3.042-2.252 4.891-4.45 4.914-4.477a2.75 2.75 0 0 0 .663-1.997Z"
  })));
};
export default SvgFavoriteIcon;